import { React } from 'react';
import { Footnote } from 'src/Common/Theme/Typography';

export const AppFooter = () => {
	return (
		<div className="app-footer">
			<Footnote className="content">© 2022 Shopee. All Rights Reserved</Footnote>
		</div>
	);
};
